import { render } from "./UpdateCategory.vue?vue&type=template&id=cec8c760"
import script from "./UpdateCategory.vue?vue&type=script&lang=js"
export * from "./UpdateCategory.vue?vue&type=script&lang=js"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__